export default __webpack_public_path__ + "static/media/distribution.9dfdc9de.svg";